import { ChangeDetectorRef, Component, HostListener, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ComprehensiveCoverService } from 'src/app/demo/service/comprehensive-cover.service';
import { ToastModule } from "primeng/toast";
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { LoadingComponent } from '../../loading/loading.component';
import { SharedComponentsModule } from 'src/app/shared/shared-components/shared-components.module';
import { InputTextareaModule } from "primeng/inputtextarea";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-comprehensive-quote-details',
  standalone: true,
  imports: [ToastModule, CommonModule, ButtonModule, AccordionModule, FormsModule, ReactiveFormsModule, RouterLink, InputTextareaModule, DialogModule, SharedComponentsModule, InputTextareaModule],
  templateUrl: './comprehensive-quote-details.component.html',
  styleUrl: './comprehensive-quote-details.component.scss',
  providers: [MessageService]
})
export class ComprehensiveQuoteDetailsComponent {
  route = inject(ActivatedRoute);
  changeDetectorRef = inject(ChangeDetectorRef);
  comprehensiveService = inject(ComprehensiveCoverService);
  domSanitizer = inject(DomSanitizer);
  quote = null;
  messageService = inject(MessageService);
  revokeReasonVisible: boolean = false;
  fb = inject(FormBuilder)
  revokeForm!: FormGroup;
  viewImageVisible: boolean = false;
  visible: boolean = false;
  revokingQuote = false;
  loadingMessage: string = '';
  screenWidth: number = 1200;
  activeIndex: number = 0;

  selectedImageUrl: string = '';
  selectedImageAngle: string = '';

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.route.params.subscribe(params => {
      const quoteId = params['id'];
      this.fetchQuoteDetails(quoteId);
    })
    this.initializeForm();
  }

  initializeForm() {
    this.revokeForm = this.fb.group({
      revokeReason: ['', Validators.required]
    });
  }

  fetchQuoteDetails(quoteId: number) {
    this.loadingMessage = 'Loading quote details...';
    this.visible = true;
    this.comprehensiveService.fetchSingleQuotation(quoteId).subscribe(
      {
        next: (data) => {
          this.quote = data;
          this.visible = false;
        },
        error: (err) => {
          console.error('Error fetching quote details:', err);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load quote details. Please try again later.' });
          this.visible = false;
        }
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
  }

  viewImage(angle: string, url: string) {
    this.viewImageVisible = true;
    this.selectedImageAngle = angle;
    this.selectedImageUrl = url;
  }

  getSafeUrl(url: string): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }

  revokePolicy() {
    this.loadingMessage = 'Revoking policy...';
    this.revokeReasonVisible = true;
    this.revokingQuote = true;
    const revokeReason = this.revokeForm.get('revokeReason')?.value;
    const payload = {
      quoteId: parseInt(this.quote['motorInsurancePolicy']['id']),
      reason: revokeReason
    };
    this.comprehensiveService.revokePolicy(payload).subscribe({
      next: (response) => {
        console.log('Policy revoked successfully:', response);
        this.revokeReasonVisible = false; this.revokingQuote = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Policy revoked successfully' });
        setTimeout(() => {
          window.history.back();
        }, 1000);
      },
      error: (err) => {
        console.error('Error revoking policy:', err);
        this.revokingQuote = false;
        this.revokeReasonVisible = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to revoke policy. Please try again later.' });
      }
    });
  }
}
